import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { QuickStartResponse } from '@/types';
import { fetchQuickStart } from '../core/quickStartService';

export const QUICK_START_QUERY_KEY = ['quick-start'] as const;

export const useQuickStartGuide = (): UseQueryResult<QuickStartResponse, Error> =>
  useQuery({
    queryKey: QUICK_START_QUERY_KEY,
    queryFn: fetchQuickStart,
    staleTime: 0,
    refetchOnMount: 'always',
  });
